<template>
  <div>
    <v-row class="pa-3 ma-0">
      <v-col cols="12">
        <BaseTitle
          pageTitle="CONSULTAR CEP"
          :hasBackButton="false"
          :hasClose="true"
          @close="close($event)"
        ></BaseTitle>
      </v-col>
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col cols="3">
            <v-text-field
              :hide-details="true"
              v-mask="['#####-###']"
              id="filter-zip_code"
              label="CEP"
              dense
              outlined
              v-model="filter.zip_code"
              append-icon="mdi-magnify"
              min="3"
              :error-messages="errorCep"
              @click:append="searchCep"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              :hide-details="true"
              id="filter-state"
              :items="estados"
              item-text="name"
              item-value="abbreviation"
              dense
              label="Estado *"
              outlined
              v-model="filter.state"
              :rules="ruleStatesViaCep"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-text-field
              :hide-details="true"
              id="filter-city"
              dense
              label="Cidade *"
              outlined
              v-model="filter.city"
              :rules="ruleViaCep"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              :hide-details="true"
              min="3"
              id="filter-street"
              dense
              label="Logradouro *"
              outlined
              v-model="filter.logradouro"
              :rules="ruleViaCep"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-btn
              :hide-details="true"
              @click="search()"
              :disabled="!valid"
              id="next"
              style="color: white"
              rounded
              color="#0894C0"
              class="mr-4"
            >
              Pesquisar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="address"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :loading="loading"
          no-data-text="Nenhum Registro encontrado"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:[`item.cep`]="{ item }">
            <span>
              <a @click="selectedCep(item)">{{ item.cep }}</a>
            </span>
          </template>
        </v-data-table>
        <div class="text-right pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BaseTitle from "../../components/UI/BaseTitle";
import { mask } from "vue-the-mask";
import { mapActions, mapGetters } from "vuex";
export default {
  directives: { mask },
  name: "Address",
  components: {
    BaseTitle
  },
  data: () => ({
    filter: {
      zip_code: "",
      state: "",
      city: "",
      logradouro: ""
    },
    modal: false,
    dialog: true,
    page: 1,
    pageCount: 0,
    itemsPerPage: 3,
    loading: false,
    valid: false,
    ruleViaCep: [
      v => !!v || "Campo obrigatório",
      v => (v && v.length >= 3) || "O campo deve conter no minimo 3 caracteres"
    ],
    ruleStatesViaCep: [v => !!v || "Campo obrigatório."],
    errorCep: [],
    headers: [
      {
        text: "Estado",
        align: "start",
        sortable: false,
        value: "uf"
      },
      { text: "Cidade", value: "localidade" },
      { text: "Bairro", value: "bairro" },
      { text: "Logradouro", value: "logradouro" },
      { text: "CEP", value: "cep" }
    ],
    address: []
  }),

  async created() {
    this.getStates();
  },

  computed: {
    ...mapGetters({
      estados: "$_address/states",
      getAddressOnViacep: "$_address/getAddressOnViacep",
      addressOnViacep: "$_address/addressOnViacep"
    })
  },

  watch: {
    errorCep() {
      setTimeout(() => {
        this.errorCep = [];
      }, 10000);
    }
  },

  methods: {
    ...mapActions({
      getStates: "$_address/showStates",
      searchAddres: "$_address/getAddressOnViacep",
      searchZipCode: "$_address/showAddressOnViaCep"
    }),

    async searchCep() {
      this.loading = true;
      this.errorCep = [];
      const cep = this.filter.zip_code.replace(/[^\d]+/g, "");

      try {
        if (cep.length < 8) {
          this.errorCep.push("Cep inválido.");
        } else {
          this.address = [];
          await this.searchZipCode(cep);
          const result = this.addressOnViacep;
          if (result) this.address.push(result);
        }
      } catch (error) {
        console.log(error);
        await this.$store.dispatch(`$_messages/setErrors`, {
          message: `Erro ao buscar CEP.`,
          type: "error",
          title: "Error!",
          timeout: 8000
        });
      }
      this.loading = false;
    },

    async search() {
      this.$refs.form.validate();
      this.loading = true;
      try {
        await this.searchAddres(this.filter);
        this.address = this.getAddressOnViacep;
      } catch (error) {
        console.log(error);
        await this.$store.dispatch(`$_messages/setErrors`, {
          message: `Erro ao buscar CEP.`,
          type: "error",
          title: "Error!",
          timeout: 8000
        });
      }
      this.loading = false;
    },

    selectedCep(item) {
      this.$emit("selectedCep", item);
      this.$emit("close", false);
    },

    close(event) {
      this.$emit("close", event);
    }
  }
};
</script>

<style lang="scss">
tbody {
  tr:nth-child(even) {
    background-color: #ebe6e6;
  }
  tr:nth-child(odd) {
    background-color: #f6f4f4;
  }
}
</style>
